import PropTypes from 'prop-types';
import { memo } from 'react';
import MarkdownToHtml from '../../../../../MarkdownToHtml';

const RateDetail = ({ product }) => (
  <div className="col-span-9 mb-2 mt-1">
    <MarkdownToHtml content={product.rateDetail} className="text-sm" />
  </div>
);

RateDetail.propTypes = {
  product: PropTypes.shape().isRequired,
};
export default memo(RateDetail);
